export const categories =
[
  {
    'Infos générales': {
      'Infos défunt': ['modifier'],
      'Infos complémentaires': ['modifier'],
      'Infos obsèques': ['modifier'],
    },
  },
  {
    'Solutions multi-services': {
      'Page du défunt': ['voirPage'],
      'Mémo obsèques': ['fichier'],
      'Condoléances': ['moderer', 'voircond'],
      'Courriers après décès': ['express', "rdv"],
      'Faire-part - Avis de décès': ['modifier', 'voir-fichier', 'fichier'],
      'Faire-part - Remerciement': ['modifier', 'voir-fichier', 'fichier'],
    },
  },
]